'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('custom', {
        url: '/custom',
        template: '<custom></custom>'
    });
}



// WEBPACK FOOTER //
// ./client/app/custom/custom.routes.js